import { INTERNSHIP_APP_API } from '../Config/config';

const finalizeGradingByUniversitySupervisor = (
  processId: string | number,
  supervisorId: string | number
): string => {
  return `${INTERNSHIP_APP_API}/internship-processes/${processId}/university-supervisors/${supervisorId}/finalize-grade`;
};

const gradeWorkReportByUniversitySupervisor = (
  processId: string | number,
  supervisorId: string | number
): string => {
  return `${INTERNSHIP_APP_API}/internship-processes/${processId}/university-supervisors/${supervisorId}/grade-work-report`;
};

const getInternshipProcessesOfUniversitySupervisor = (
  supervisorId: string | number
): string => {
  return `${INTERNSHIP_APP_API}/university-supervisors/${supervisorId}/internship-processes`;
};

const gradeWorkLog = (workLogId: string | number): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${workLogId}/grade`;
};

export {
  getInternshipProcessesOfUniversitySupervisor,
  finalizeGradingByUniversitySupervisor,
  gradeWorkLog,
  gradeWorkReportByUniversitySupervisor,
};
